import service from '@/services/report/report'

const getDefaultState = () => ({
  listIva: []

  // pageInfo: {},
  // totalRegistros: 0
})

export const state = () => getDefaultState()

export const mutations = {
  SET_LIST: (state, value) => {
    state.listIva = value
  }
}

export const actions = {
  readIvaByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false, filter = null }) => {
    // if (restart) await dispatch('resetList')

    return service.readIvaByEmisor(rootGetters['facturacion/emisorStore/get_Id'], filter.start, filter.end).then(async response => {
      commit('SET_LIST', response)
      dispatch(
        'contabilidad/ivaStore/findOne',
        {
          restart: true,

          start: filter.start,
          end: filter.end
        },
        { root: true }
      )

      return
    })
  }
}

export const getters = {}
